import React from 'react';
import { motion } from "framer-motion";
import { black, blackblue } from "./data";
import { ThemeContext } from '..';

export const ContectUs = () => {
    const darkMode = React.useContext(ThemeContext);
    return (
        <section className="section is-medium contect-form" style={{ background: darkMode ? black : blackblue, height: "max-content" }} id="contect">
            <motion.div
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 1.0 }}
            >
                <div className="column is-half is-offset-one-quarter">
                    <div className="title">Contect Us</div>
                    <form action="https://getform.io/f/e92c0a89-5a06-4e1c-8b70-5627157e6854" method="POST">

                        <div className="column">
                            <div className="field">
                                <label className="label">Name</label>
                                <div className="control is-expanded">
                                    <input className="input is-small" name="name" type="text" required />
                                </div>
                            </div>
                        </div>
                        <div className="column">
                            <div className="field">
                                <label className="label">Email</label>
                                <div className="control is-expanded">
                                    <input className="input is-small" name="email" type="email" required />
                                </div>
                            </div>
                        </div>

                        <div className="column">
                            <div className="field">
                                <label className="label">Message</label>
                                <div className="control is-expanded">
                                    <textarea className="textarea is-small" name="message" rows="5" required></textarea>
                                </div>
                            </div>
                        </div>
                        <div className="column" style={{ display: "flex", justifyContent: "end" }}>
                            <div className="field">
                                <div className="control">
                                    <button className="button-outline" style={{ padding: "6px 20px " }} type="submit">Send</button>
                                </div>
                            </div>

                        </div>
                    </form>
                </div>
            </motion.div>


        </section>
    )
}